export default "__VITE_ASSET__Bc_jAuMb__"